import { useModuleBEM } from "@b2bportal/core-themes";
import type { Funnel } from "@b2bportal/core-types";
import { Button, ButtonTypeEnum } from "@tenant/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";
import { usePremierDestinationHomepageBanner } from "./usePremierDestinationHomepageBanner";

export interface PremierDestinationHomepageBannerProps {
  className?: string;
  funnel: Funnel;
}

export const PremierDestinationHomepageBanner = ({
  className,
  funnel,
}: PremierDestinationHomepageBannerProps) => {
  const [block, cn] = useModuleBEM(styles, "PremierDestinationHomepageBanner");

  const { enabled, titleMap, handleClick, images } =
    usePremierDestinationHomepageBanner(funnel);

  return enabled ? (
    <Button
      className={clsx(block, className)}
      buttonType={ButtonTypeEnum.Wrap}
      onClick={handleClick}
      style={{
        backgroundImage: `url(${images.bannerPremierDestination})`,
      }}
    >
      <p className={cn("title")}>{titleMap[funnel]}</p>
    </Button>
  ) : null;
};
